export default "__VITE_ASSET__BNkxR0mL__"